import PlazaMessages from '../assets/messages/14766';
import NederlandsMessages from '../assets/messages/3714';
import CompostelaMessages from '../assets/messages/6460';
import PortoSantaCatarinaConfig from '../assets/messages/301';
import BuenosAiresItaliaCatarinaConfig from '../assets/messages/3327';
import BatterSeaConfig from '../assets/messages/14512';
import JuanDeAustriaConfig from '../assets/messages/12477';
import ChampsElyseesConfig from '../assets/messages/14914';
import AreseShoppingCenterConfig from '../assets/messages/6437';
import MilVittorioEmmanueleConfig from '../assets/messages/3197';
import DubaiMoEConfig from '../assets/messages/3488';
import RoterdamConfig from '../assets/messages/14965';
import SevillaDuqueConfig from '../assets/messages/16231';

export const StoreMessageSelector = (storeId) => {
  switch (storeId) {
    case '14766':
      return PlazaMessages;
    case '3714':
      return NederlandsMessages;
    case '6460':
      return CompostelaMessages;
    case '301':
      return PortoSantaCatarinaConfig;
    case '3327':
      return BuenosAiresItaliaCatarinaConfig;
    case '14512':
      return BatterSeaConfig;
    case '12477':
      return JuanDeAustriaConfig;
    case '14914':
      return ChampsElyseesConfig;
    case '6437':
      return AreseShoppingCenterConfig;
    case '3197':
      return MilVittorioEmmanueleConfig;
    case '3488':
      return DubaiMoEConfig;
    case '14965':
      return RoterdamConfig;
    case '16231':
      return SevillaDuqueConfig;
    default:
      return PlazaMessages;
  }
};
